import { useState } from 'react';

export type BulkImportFeedbackService = {
	isFeedbackModalOpen: boolean;
	closeFeedbackModal: () => void;
	openFeedbackModal: () => void;
};

/**
 * Service object for managing the state of the bulk import feedback modal.
 * Exposes methods across Confluence Frontend and Canvas (Whiteboards) via the WhiteboardBridgeAPI.
 */
export const useBulkImportFeedbackService = () => {
	const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);

	const bulkImportFeedbackService: BulkImportFeedbackService = {
		isFeedbackModalOpen,

		closeFeedbackModal: () => {
			setIsFeedbackModalOpen(false);
		},

		openFeedbackModal: () => {
			setIsFeedbackModalOpen(true);
		},
	};

	return bulkImportFeedbackService;
};
